import {
  getAmplitudeProxyUrl,
  getAppEnv,
  isLocalHost,
  isPreview,
} from '@src/utils';
import { ampli } from './ampli';
import { init } from '@amplitude/analytics-browser';
export const initAmplitude = (concent: boolean) => {
  const appEnv = getAppEnv();
  const amplitudeApiKey =
    appEnv === 'prod'
      ? 'd2a0e86d1828a7cd30fb17038dfa0645'
      : 'c30218ffaa74aa2ace0e27fa020b9d78';
  if (!ampli.isLoaded && !isPreview()) {
    init(amplitudeApiKey, {
      serverUrl: getAmplitudeProxyUrl(),
      optOut: !concent,
      autocapture: {
        attribution: true,
        pageViews: true,
        sessions: true,
        formInteractions: true,
        fileDownloads: false,
        elementInteractions: false,
      },
    });
    ampli.load({
      disabled: !concent,
      client: {
        apiKey: amplitudeApiKey,
        configuration: {
          autocapture: {
            pageViews: true,
            sessions: true,
            attribution: true,
            formInteractions: true,
            elementInteractions: false,
          },
          serverUrl: getAmplitudeProxyUrl(),
          trackingOptions: { ipAddress: false },
          flushMaxRetries: 3,
          optOut: !concent,
        },
      },
    });
  }
};
